import { GuideLink, type GuideSurfaceId } from '@features/knowledge-base/links';

import { entitlementGuideTarget } from '../guideTopics';

export interface EntitlementGuideLinkProps {
  /** The blocked capability; unknown or missing names link to the access article alone. */
  capabilityName?: string;
  /** The shared entitlement component hosting the link (analytics). */
  surfaceId: GuideSurfaceId;
}

/**
 * "How {feature} works" under the primary action of a blocked entitlement
 * state. Renders nothing while the guide-links gate is closed or no article
 * is published, so the host layout must not reserve space for it.
 */
export function EntitlementGuideLink({ capabilityName, surfaceId }: EntitlementGuideLinkProps) {
  return (
    <GuideLink
      shape="secondary-action"
      surfaceId={surfaceId}
      {...entitlementGuideTarget(capabilityName)}
    />
  );
}
